import * as React from 'react';

import RichInputField from 'bundles/ai-coach-platform/components/patterns/chat/common/RichInputField';
import QuickAccessToolbar from 'bundles/ai-coach-platform/components/patterns/popover/components/QuickAccessToolbar';
import type { Action } from 'bundles/ai-coach-platform/components/patterns/popover/types';

type Props = {
  value: string;
  placeholder?: string;
  actions?: Action[];

  onChange: (value: string) => void;
  onSend: (value: string) => void;
  onClose: () => void;
};

/**
 * QuickAccessBody renders the QuickAccessPopover dropdown body with a list of quick actions and a text field
 * for user input.
 */
const QuickAccessBody = ({ value, placeholder, actions, onSend, onChange, onClose }: Props) => {
  return (
    <div>
      <QuickAccessToolbar actions={actions} onClose={onClose} />
      <RichInputField value={value} placeholder={placeholder} onTextInputChange={onChange} onSend={onSend} />
    </div>
  );
};

export default QuickAccessBody;
